/**
 * @module StepDetallePago
 * @description Paso 3 del flujo de pagos en línea.
 * Presenta el resumen del pago antes de proceder al checkout con ePayco.
 * Muestra información del servicio, referencia activa, fecha de vencimiento
 * y el total a pagar calculado según la modalidad seleccionada (mínimo, total u otro valor).
 */

import { FC } from "react";
import { usePagosOnline } from "../PagosOnlineContext";
import { ResumenPago } from "../DetailPago";

const StepDetallePago: FC = () => {
  const { estado } = usePagosOnline();

  return (
    <div data-kt-stepper-element="content">
      <div className="w-100 bg-secondary bg-gradient rounded-3 p-3">
        <h4>Resumen pago</h4>
        {/* Componente de resumen: servicio, referencia, vencimiento y total */}
        <ResumenPago estado={estado} />
      </div>
    </div>
  );
};

export { StepDetallePago };
